import TaskViewAsOwner from './TaskViewAsOwner';
import RightSidebarViewTaskAsOwner from './RightSidebarViewTaskAsOwner';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

export default ColumnsContent(TaskViewAsOwner, RightSidebarViewTaskAsOwner);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskViewAsOwner/Content.js